import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServerConfigService } from '@app/configuration/server-config.service';
import { UserService } from '@features/auth/user.service';
import { DataLayerService } from '@features/tag-manager/data-layer.service';
import { FeedbackEvent } from './feedback-event.enum';

@Injectable()
export class FeedbackService {
  private sub: string;

  private email: string;

  constructor(
    private http: HttpClient,
    private serverConfigService: ServerConfigService,
    private userService: UserService,
    private dataLayerService: DataLayerService,
  ) {
    this.userService.user$.subscribe((user) => {
      const { sub, email } = user;
      this.sub = sub;
      this.email = email;
    });
  }

  post(subject: string, body: string) {
    this.dataLayerService.push(FeedbackEvent.feedback, {
      subject,
      body,
      email: this.email,
      sub: this.sub,
    });

    return this.http.post(
      `${this.serverConfigService.config.apiBaseUrl}/feedback`,
      {
        subject, body, email: this.email, name: this.sub,
      },
    );
  }
}
